// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"7010":"92d510d1f8c70ae3","9444":"a20371621e42886e"}[chunkId] + ".css";
};